const USERS = [
    {
        _id: '2',
        firstName: 'Bart',
        lastName: 'Lenaerts'
    },
    {
        _id: '1',
        firstName: 'Benoît',
        lastName: 'De Rese',
        disabled: true
    },
    {
        _id: '0',
        firstName: 'Sébastien',
        lastName: 'Declève'
    }
]

export default USERS


// WEBPACK FOOTER //
// ./src/constant/USERS.js